import React, { useState } from "react";
import { Form } from "antd";
import { IDocumentList } from "store/process/process-model";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "../styled/form.styled";
import AddDocuments from "./addDocuments";

export interface IAddDocuments {
  documentsList: IDocumentList[];
  eventOutboundActive: boolean;
  eventInboundActive: boolean;
  visibleDocuments: boolean;
  processUpdateVisibleDocuments: (...args) => void;
}

const defaultFields = [
  {
    fieldKey: 0,
    isListField: true,
    key: 0,
    name: 0,
  },
];

const Document = ({ documentsList, eventInboundActive, eventOutboundActive, processUpdateVisibleDocuments, visibleDocuments }: IAddDocuments) => {
  const [countFields, setCountFields] = useState(1);
  const DOCUMENT_LABEL = `${useTranslation({ id: "document" })}`;
  return (
    <S.FormItem
      name="document"
      label={DOCUMENT_LABEL}
      style={S.ProcessesFormItem}
      rules={[
        {
          required: false,
        },
      ]}
    >
      <Form.List name="documents" initialValue={[""]}>
        {(fields, { add, remove }) => {
          if (fields.length === 0) {
            fields = defaultFields;
          }
          return (
            <AddDocuments
              fields={fields}
              setFieldsCount={setCountFields}
              fieldsCount={countFields}
              add={add}
              remove={remove}
              documentsList={documentsList}
              eventInboundActive={eventInboundActive}
              eventOutboundActive={eventOutboundActive}
              processUpdateVisibleDocuments={processUpdateVisibleDocuments}
              visibleDocuments={visibleDocuments}
            />
          );
        }}
      </Form.List>
    </S.FormItem>
  );
};

export default Document;
